const MAP_CONSTANTS = {
	SEOUL_CITY_HALL_COORDINATES: [126.97794511009269, 37.56633133980686],
	DEAFULT_ZOOM: 16,
};

export default MAP_CONSTANTS;
